// extracted by mini-css-extract-plugin
export var hidden = "_td-0";